import { LWApiPublic } from '@liquidweb-dev/club-sauce';
import getAppConfigs from 'modules/appConfig/reducer';
import { fixedUrl, localUrl } from './api';

const appConfigs = getAppConfigs();

/**
 * Auth is always set to guest auth credentials. Only use this for endpoints that *always* require guest auth.
 */
const apiBasicAuth = new LWApiPublic({
	url: localUrl || fixedUrl,
});

apiBasicAuth.utilities.info.apiRaw.apiSetBasicAuthorization(
	appConfigs?.guestAuth.username || '',
	appConfigs?.guestAuth.password || '',
);

export default apiBasicAuth;
